@if (toast.message(); as message) {
  <div
    class="bf-toast"
    role="status"
    aria-live="polite"
  >
    {{ message }}
  </div>
}
